import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();
import Collapse from 'bootstrap/js/dist/collapse';

import * as lightboxAccessibility from './scripts/lightbox-accessibility';
lightboxAccessibility.init();

import * as playVideo from './scripts/play-video';
playVideo.init();


import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();


import * as parallax from "./scripts/parallax";
parallax.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as googleMap from "./scripts/google-map";
googleMap.init();

import * as lightboxTracking from './scripts/lightbox-tracking';
lightboxTracking.init();

import * as wishlist from './scripts/wishlist';
wishlist.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();